module.exports = __webpack_public_path__ + "img/warning.b2b01ed3.svg";